export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

interface Props {
    value?: string
    model?: string | null
    tools?: string[]
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {value: '', model: 'gpt-4o', tools: ['think', 'internet'] as string[]};
    }

    isToolSelected(tool: string) {
        return (this.get('tools') || []).includes(tool);
    }

    getToolIconColor(tool: string) {
        return this.isToolSelected(tool) ? '#0091ea' : '#848f9a';
    }
}